import styled from "styled-components"
import { tabletPortrait, mobile, tablet } from "../../Responsive"

export const Container = styled.div`
   width: auto;
   max-width: 33%;
   height: 100%;
   display: flex;
   align-items: center;
   justify-content: center;
   border-radius: 10px;

   ${tabletPortrait({ width: "100%", height: "33%" })}
`

export const Wrapper = styled.div`
   display: grid;
   grid-template-columns: repeat(4, 1fr);
   gap: 1px;
   height: calc(100vh - 120px);

   ${tablet({ height: "calc(100vh - 90px)" })}
   ${mobile({ height: "calc(100vh - 40px)" })}
    ${tabletPortrait({
      gridTemplateColumns: "repeat(8, 1fr)",
      height: "auto",
      width: "100vw",
   })}
`

export const GridImage = styled.img`
   width: calc((100vh - 120px) / 8);
   height: calc((100vh - 120px) / 8);
   object-fit: cover;

   ${tablet({
      width: "calc((100vh - 90px) / 8)",
      height: "calc((100vh - 90px) / 8)",
   })}
   ${mobile({
      width: "calc((100vh - 40px) / 8)",
      height: "calc((100vh - 40px) / 8)",
   })}
    ${tabletPortrait({ width: "calc(100vw / 8)", height: "calc(100vw / 8)" })}
`
